
import { Controller } from "stimulus"
import WaveSurfer from "wavesurfer.js"

export default class extends Controller {
  static values = { 
    audioReady: Boolean,
    audio: String,
    peaks: Array
  }

  createWaveSurfer(waveformElement) {
    if (this.wavesurfer) {
      this.wavesurfer.destroy();
    }
    const options = {
      container: '#' + waveformElement,
      waveColor: "rgba(228, 231, 235, 1)",
      progressColor: "rgba(121, 135, 155, 1)",
      cursorColor: "black",
      barWidth: 3,
      barHeight: 2,
      barGap: 2,
      barRadius: 5,
      pixelRatio: 2,
      normalize: true,
      fillParent: true,
      responsive: true,
      partialRender: true,
      backend: "MediaElement",
      mediaType: "audio",
      skipLength: 10,
      interact: this.audioReadyValue
    };

    this.wavesurfer = WaveSurfer.create(options);

    // this.wavesurfer.on("audioprocess", () => {
    //   this.audioCurrentTime = this.wavesurfer.getCurrentTime();
    //   this.audioDuration = this.wavesurfer.getDuration();
    // });

    // this.wavesurfer.on("seek", () => {
    //   this.audioCurrentTime = this.wavesurfer.getCurrentTime();
    //   this.audioDuration = this.wavesurfer.getDuration();
    // });

    // this.wavesurfer.on("ready", () => {
    //   this.audioCurrentTime = this.wavesurfer.getCurrentTime();
    //   this.audioDuration = this.wavesurfer.getDuration();
    //   this.waveformLoaded = true;
    // });

    // this.wavesurfer.on("finish", () => {
    //   this.paused = true;
    // });

    this.wavesurfer.on("error", err => {
      console.error(err);
      // this.loadingError = true;
      // this.waveformLoaded = true;
    });

    let finalAudio;
    if (this.audioReadyValue) {
      finalAudio = this.audioValue;
    } else {
      finalAudio = "https://s3-eu-west-1.amazonaws.com/muc-public/test_tone.mp3";
    }

    this.paused = true
    
    this.wavesurfer.load(finalAudio, this.peaksValue);
  }

  playPause(event) {
    let playPauseButton = document.getElementById('playPauseButton')
    if (this.paused) {
      playPauseButton.innerHTML = '<i class="fas fa-pause"></i> Pause audio'
    } else {
      playPauseButton.innerHTML = '<i class="fas fa-play"></i> Play audio'
    }
    this.paused = !this.paused;
    this.wavesurfer.playPause();
  }

  redraw() {
    this.wavesurfer.drawBuffer();
  }

  initialize() {
    let waveformElement = this.targets.element.children[0].id;
    this.createWaveSurfer(waveformElement);
  }
}
